import React from 'react';
import { createVersionedContext, createVersionedValueMap } from '@backstage/version-bridge';

const AppContext = createVersionedContext("app-context");
const AppContextProvider = ({
  appContext,
  children
}) => {
  const versionedValue = createVersionedValueMap({ 1: appContext });
  return /* @__PURE__ */ React.createElement(AppContext.Provider, { value: versionedValue, children });
};

export { AppContextProvider };
//# sourceMappingURL=AppContext.esm.js.map
